import { Injectable } from '@angular/core';
import { UK_Zones } from '../core/constants/ZonesIds';

@Injectable({
  providedIn: 'root'
})
export class DistanceUnitByZoneIdService {
  transform(zoneId: string | undefined): string {
    if (zoneId) {
      if (UK_Zones.includes(zoneId)) {
        return "mi";
      }
    }
    return "km";
  }
}
